// PythonFormatter.js
export const formatPython = (code) => {
  try {
    if (!code) return { convertedData: '', isError: false };

    const lines = code.split('\n');
    let indentLevel = 0;

    const formatted = lines.map(line => {
      const trimmed = line.trim();

      // Preserve empty lines
      if (!trimmed) return '';

      // These keywords align with their opening block, so dedent before rendering
      if (/^(elif\b|else:|except(\s.*)?:|finally:)/.test(trimmed)) {
        indentLevel = Math.max(indentLevel - 1, 0);
      }

      const indentedLine = '    '.repeat(indentLevel) + trimmed;

      // Any line ending with ':' opens a new indented block
      if (trimmed.endsWith(':')) {
        indentLevel++;
      }

      return indentedLine;
    });

    return { convertedData: formatted.join('\n'), isError: false };
  } catch (err) {
    return { convertedData: 'Error: Invalid Python code', isError: true };
  }
};


// TypeScriptFormatter.js
export const formatTypeScript = (code) => {
  try {
    if (!code) return { convertedData: '', isError: false };

    // Step 1: Extract all string/template literals and replace with placeholders
    // so that { } ; inside strings are never touched by the formatter.
    const strings = [];
    let processed = code;

    // Template literals first (they may contain quotes internally)
    processed = processed.replace(/`(?:[^`\\]|\\.)*`/g, (match) => {
      strings.push(match);
      return `__STR${strings.length - 1}__`;
    });
    // Double-quoted strings
    processed = processed.replace(/"(?:[^"\\]|\\.)*"/g, (match) => {
      strings.push(match);
      return `__STR${strings.length - 1}__`;
    });
    // Single-quoted strings
    processed = processed.replace(/'(?:[^'\\]|\\.)*'/g, (match) => {
      strings.push(match);
      return `__STR${strings.length - 1}__`;
    });

    // Step 2: Format only the structural code
    let formatted = processed
      .replace(/;\s*/g, ';\n')
      .replace(/{\s*/g, '{\n')
      .replace(/}\s*/g, '\n}\n')
      .replace(/,\s*/g, ', ')
      .replace(/\n\s*\n/g, '\n')
      .split('\n')
      .map(line => line.trim())
      .filter(line => line !== '')
      .join('\n');

    // Step 3: Apply indentation based on braces
    let indent = 0;
    const indented = formatted.split('\n').map(line => {
      if (line.startsWith('}')) indent = Math.max(indent - 1, 0);
      const indentedLine = '  '.repeat(indent) + line;
      if (line.endsWith('{')) indent++;
      return indentedLine;
    }).join('\n');

    // Step 4: Restore the original string/template literal content
    const result = indented.replace(/__STR(\d+)__/g, (_, idx) => strings[parseInt(idx)]);

    return { convertedData: result, isError: false };
  } catch (err) {
    return { convertedData: 'Error: Invalid TypeScript code', isError: true };
  }
};

export const formatCss = (css) => {
    const lines = css
        .replace(/\s*{\s*/g, " {\n  ")
        .replace(/\s*}\s*/g, "\n}\n")
        .replace(/\s*;\s*/g, ";\n  ")
        .split('\n');

    // Only normalise ':' on indented lines (property declarations inside a rule block).
    // Selector lines like 'a:hover {' and URL values like 'url(https://...)' are NOT indented,
    // so they are left untouched.
    return lines.map(line => {
        if (/^\s+/.test(line)) {
            return line.replace(/^(\s*)([\w-]+)\s*:\s*(?!\/\/)/, '$1$2: ');
        }
        return line;
    }).join('\n').replace(/\n{3,}/g, '\n\n').trim();
};
